import { Box, Tag, Text } from '@bechtel/gds';
import { getSplittedToolCatalogName } from '@bechtel/ht-clients-common';
import { FC, useMemo } from 'react';
import { CatalogInfoProps } from './type';

export const CatalogInfo: FC<CatalogInfoProps> = ({ isSerialized, uomAbbreviation, description, barCode }) => {
  const toolCatalogDetails = useMemo(() => {
    return getSplittedToolCatalogName(description);
  }, [description]);
  return (
    <>
      <div>
        <Tag bgColor={isSerialized ? 'orange.200' : 'neutral.200'}>
          <Text size="300" family="openSansCondensed">
            {barCode}
          </Text>
        </Tag>
      </div>
      <Box flexDirection={{ sm: 'column' }} gap={{ sm: '200' }}>
        <Text color="blue.800" weight="600" size="450" family="openSansSemiBold">
          {toolCatalogDetails.title}
        </Text>
        {(toolCatalogDetails.subTitle || uomAbbreviation) && (
          <Text color="blue.800" weight="500" size="300" family="openSans">
            {uomAbbreviation ? `${toolCatalogDetails.subTitle} (${uomAbbreviation})` : toolCatalogDetails.subTitle}
          </Text>
        )}
      </Box>
    </>
  );
};
